import Vue from 'vue';
import Router from 'vue-router';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'start',
      redirect: '/analysis',
      props: true,
    },
    {
      path: '/login',
      name: 'login',
      alias: '/',
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import('@/views/CompanySelection.vue'),
      props: true,
    },
    {
      path: '/analysis',
      component: () => import('@/layouts/Layout.vue'),
      props: true,
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('@/views/CompareGroups.vue'),
          props: true,
        },
        {
          path: '/purchase',
          name: 'purchase',
          component: () => import('@/views/PurchaseScreen.vue'),
          props: true,
        },
        {
          path: '/access-denied',
          name: 'access-denied',
          component: () => import('@/views/WithoutAccessToBenchmarks.vue'),
          props: true,
        },
      ],
    },
    {
      path: '/setup',
      name: 'setup',
      props: true,
      component: () => import('@/layouts/LayoutSetup.vue'),
      redirect: '/setup/management-benchmarks',
      children: [
        {
          path: 'management-benchmarks',
          name: 'managementBenchmarks',
          component: () => import('@/views/ManagementBenchmarks.vue'),
          props: true,
        },
        {
          path: 'new-benchmarks',
          name: 'newBenchmarks',
          component: () => import('@/views/NewBenchmarks.vue'),
          props: true,
        },
        {
          path: 'edit-benchmarks',
          name: 'editBenchmarks',
          component: () => import('@/views/EditBenchmarks.vue'),
          props: true,
        },
      ],
    },
    {
      path: '*',
      redirect: '/analysis',
      props: true,
    },
  ],
});

export default router;
